import { Injectable } from '@angular/core';
import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { take } from 'rxjs/operators';

import { getTenantName } from 'src/app/branding/store/branding.selectors';

import * as barnActions from '../store/actions/barn.actions';

@Injectable()
export class BarnResolver {
  constructor(private readonly store: Store<RootState>) {}

  resolve(): Observable<boolean> {
    this.store.dispatch(barnActions.loadBarnsRequest());
    this.store
      .select(getTenantName)
      .pipe(take(1))
      .subscribe((tenantName: string) => {
        if (tenantName == 'Agrifirm') {
          this.store.dispatch(barnActions.loadSilosRequest());
        }
      });

    return of(true);
  }
}
